module.exports = __webpack_public_path__ + "static/media/house-storage.67230be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/house/house-storage.png
// module id = 198
// module chunks = 0